<template>
  <div class="fotersa">
    <div class="head-input">
      <a-form :layout="formLayout">
        <a-row :gutter="24" type="flex" justify="start">
          <a-col :span="6" class="fl fw">
            <a-form-item
              label="字典名称:"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-input
                placeholder="请输入"
                v-model="busName"
                :allowClear="true"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6" class="fl1 fw">
            <a-form-item
              label="字典值:"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-input
                placeholder="请输入"
                :allowClear="true"
                v-model="busCode"
              />
            </a-form-item>
          </a-col>

          <a-col :span="6" class="oper">
            <div style="height: 41px; line-height: 41px;margin-left:-18px">
              <a-button class="btone" @click="searchList(1)">查询</a-button>
              <a-button class="bttwo" style="margin-left:-11px" @click="showModal">新增</a-button>
              <a-button class="btthree" @click="showReturn"
                >返回上级菜单</a-button
              >
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 展示内容 -->
    <div class="base-content">
      <!-- 表格 -->
      <a-table
        :columns="columns"
        :rowKey="
          (record, index) => {
            return index;
          }
        "
        :data-source="tableData"
        :pagination="false"
        bordered
        size="small"
        :scroll="{ x: 1000, y: 'calc(100vh - 300px)' }"
        class="table"
      >
        <span slot="index" slot-scope="text, record, index">
          {{index + (pageNum-1) * pageSize + 1}}
        </span>
        <span slot="status" slot-scope="text, record">
          <span v-if="record.status == 0"><a-badge color="cyan" /></span>
          <span v-else-if="record.status == 1"><a-badge color="red" /></span>
          {{ record.status | DictionaryFilter("DICT_STATUS") }}
        </span>
        <!-- 操作 -->
        <template slot="operation" slot-scope="text">
          <a-button href="javascript:;" @click="onDelete(text, 'update')" class="btcation">编辑</a-button>
          <a-button href="javascript:;" @click="handleDelete(text)" class="btcation">删除</a-button>
        </template>
      </a-table>

      <!-- 分页 -->
      <div class="base-pagination">
        <div class="total-view">
          共{{ totalRows }}条数据，第{{ pageNum }}/{{ totalPages }}页
        </div>
        <div class="pagination-buttons">
          <a-pagination
            v-model="pageNum"
            :total="totalRows"
            :defaultPageSize="pageSize"
            show-less-items
            @change="changePageFn($event)"
          />
        </div>
      </div>
      <!-- 确定新增 + 编辑 -->
      <a-modal
        v-model="visible"
        on-ok="handleOk"
        :destroyOnClose="true"
        :maskClosable="false"
        v-if="visible"
        @cancel="handleCancel"
      >
      <div slot="title" class="tip-icon"> {{Title}} </div>
        <template slot="footer">
          <a-button
            key="submit"
            class="btaction"
            :loading="loading"
            @click="handleOk"
            :disabled="disabled"
          >
            确认
          </a-button>
        </template>
        <div class="add-mess">
          <a-form-model
            ref="ruleForm"
            :model="form"
            :rules="rules"
            class="input-input"
          >
            <a-form-model-item ref="busCode" label="字典值" prop="busCode">
              <a-input
                :disabled="disabled"
                v-model="form.busCode"
                placeholder="请输入字典值"
              />
            </a-form-model-item>

            <a-form-model-item ref="busName" label="字典名称 " prop="busName">
              <a-input
                :disabled="disabled"
                v-model="form.busName"
                placeholder="请输入字典名称"
              />
            </a-form-model-item>
            <a-form-model-item ref="filterValue" label="过滤值 " prop="filterValue">
              <a-input
                :disabled="disabled"
                v-model="form.filterValue"
                placeholder="请输入过滤值"
              />
            </a-form-model-item>
            <a-form-model-item ref="orderNumber" label="排序 " prop="orderNumber">
              <a-input
                type="number"
                :disabled="disabled"
                v-model="form.orderNumber"
                placeholder="请输入排序"
              />
            </a-form-model-item>

            <a-form-model-item ref="status" label="状态" prop="status">
              <a-select
                show-search
                v-model="form.status"
                placeholder="请选择状态"
              >
                <a-select-option
                  v-for="item in dictStatus"
                  :key="item.busCode"
                  :value="item.busCode"
                  >{{ item.busName }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
            <a-form-model-item ref="remark" label="备注" prop="remark">
              <a-input
                :disabled="disabled"
                v-model="form.remark"
                placeholder="请输入备注"
                type="textarea"
              />
            </a-form-model-item>
          </a-form-model>
        </div>
      </a-modal>
    </div>
  </div>
</template>
<script>
import {
  pagedictList,
  pagedictAdd,
  pagedictUpdate,
  pagedictDel,
  dictById
} from "@/api/api.js";
import { DictionaryService } from "@common/services/dictionary.service";
import moment from "moment";
moment.locale("zh-cn");
export default {
  data() {
    var checkAge = (rule, value, callback) => {
      if (value) {
        if (!Number.isInteger(Number(value))) {
          return callback(new Error('请输入整数'));
        } else {
          return callback();
        }
      } else {
        return callback();
      }
    };
    return {
      busTypeCode: "",
      busName: "",
      busCode: "",
      //表格
      tableData: [],
      Title: "",
      //新增弹出框
      visible: false,
      // 表单验证
      rules: {
        busCode: [
          {
            required: true,
            message: "请输入字典值",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        busName: [
          {
            required: true,
            message: "请输入字典名称  ",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        busTypeCode: [
          {
            required: true,
            message: "请输入字典类型编码  ",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        remark: [{
          max: 100,
          message: '备注长度不能超过100'
        }],
        filterValue: [{
          max: 50,
          message: '备注长度不能超过50'
        }],
        orderNumber: [
        {
          validator: checkAge,
          trigger: "change",
        }
        ],
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change",
          },
        ],
      },
      form: {
        busCode: "",
        busName: "",
        busTypeCode: "",
        filterValue: "",
        orderNumber:"",
        remark: "",
        status: undefined
      },
      loading: false,
      Tableloading: false,
      disabled: false,
      //数列
      columns: [
        {
          title: "序号",
          align: "center",
          dataIndex: "index",
          width: 23,
          key: "index",
          ellipsis: true,
          scopedSlots: { customRender: "index" },
        },
        {
          title: "字典值",
          dataIndex: "busCode",
          key: "busCode",
          align: "center",
          ellipsis: true,
          width: 67,
          scopedSlots: { customRender: "busCode" },
        },
        {
          title: "字典名称",
          dataIndex: "busName",
          key: "busName",
          align: "center",
          ellipsis: true,
          width: 60,
          scopedSlots: { customRender: "busName" },
        },
        {
          title: "字典类型编码",
          dataIndex: "busTypeCode",
          key: "busTypeCode",
          align: "center",
          ellipsis: true,
          width: 60,
          scopedSlots: { customRender: "busTypeCode" },
        },
        {
          title: "过滤值",
          dataIndex: "filterValue",
          key: "filterValue",
          align: "center",
          ellipsis: true,
          width: 50,
          scopedSlots: { customRender: "filterValue" },
        },
        {
          title: "排序",
          dataIndex: "orderNumber",
          key: "orderNumber",
          align: "center",
          ellipsis: true,
          width: 30,
          scopedSlots: { customRender: "orderNumber" },
        },
        {
          title: "备注",
          dataIndex: "remark",
          key: "remark",
          align: "center",
          ellipsis: true,
          width: 95,
          scopedSlots: { customRender: "remark" },
        },

        {
          title: "状态",
          dataIndex: "status",
          key: "status",
          align: "center",
          width: 35,
          scopedSlots: { customRender: "status" },
        },
        {
          title: "操作",
          key: "operation",
          align: "center",
          width: 80,
          scopedSlots: {
            customRender: "operation",
          },
        },
      ],
      pageNum: 1,
      pageSize: 10,
      totalRows: 0,
      totalPages: 0,
      dictStatus: [],
      formLayout: "horizontal",
    };
  },
  watch: {
    Title(newVal, oldVal) {
      if (
        (oldVal === "字典修改" || oldVal === "字典详情") &&
        this.visible == true
      ) {
        if (newVal == "字典新增") {
          this.form = this.$options.data().form;
        }
      }
    },
  },
  activated() {
    DictionaryService.getAllNeedDic(["DICT_STATUS"]).then((res) => {
      this.searchList();
      this.dictStatus = DictionaryService.getOptions("DICT_STATUS");
    });
  },
  mounted() {
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
          }
        : {};
    },
    buttonItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            wrapperCol: { span: 6, offset: 18 },
          }
        : {};
    },
  },
  methods: {
    //返回
    showReturn() {
      this.$router.push({
        path: "/home/system/dictionary",
      });
    },
    //分页
    changePageFn(event) {
      this.pageNum = event;
      this.searchList();
    },
    //列表查询
    searchList(sum = 2) {
      this.busTypeCode = this.$route.query.busTypeCode;

      if (sum == 1) this.pageNum = 1;
      let obj = {
        pageParam: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          orderBy: "",
        },
        content: {
          busCode: this.busCode,
          busName: this.busName,
          busTypeCode: this.busTypeCode,
        },
      };
      pagedictList(obj).then(
        (res) => {
          this.tableData = res.content.rows;
          this.totalRows = res.content.page.totalRows;
          this.totalPages = Math.ceil(this.totalRows / this.pageSize);
        },
        (err) => {}
      );
    },
    //新增弹窗
    showModal() {
      this.disabled = false;
      this.visible = true;
      this.Title = "字典新增";
    },
    onDelete(key, type) {
      type == "update"
        ? ((this.Title = "字典修改"), (this.disabled = false))
        : ((this.Title = "字典详情"), (this.disabled = true));
      this.visible = true;
      if (type == "update") {
        dictById({ id: key.id }).then((res) => {
          this.form.busCode = res.content.busCode;
      this.form.busName = res.content.busName;
      this.form.filterValue = res.content.filterValue;
      this.form.orderNumber = res.content.orderNumber;
      this.form.remark = res.content.remark;
      this.form.status = res.content.status;
      this.form.id = res.content.id;
        })
      }
     
     
    },

    // 确定新增 + 编辑
    handleOk(e) {
      this.loading = true;
      this.form.busTypeCode = this.$route.query.busTypeCode;
      // 判断是新增还是编辑
      if (this.Title == "字典修改") {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            pagedictUpdate({
              busCode: this.form.busCode,
              busName: this.form.busName,
              busTypeCode: this.form.busTypeCode,
              filterValue: this.form.filterValue,
              orderNumber: this.form.orderNumber,
              remark: this.form.remark,
              status: this.form.status,
              id: this.form.id,
            }).then(
              (res) => {
                this.$nextTick(() => {
                  this.$refs["ruleForm"].resetFields();
                });

                this.visible = false;
                this.loading = false;
                this.searchList();
                this.$message.success("修改成功");
              },
              (err) => {
                this.loading = false;
              }
            );
          } else {
            this.loading = false;
            return false;
          }
        });
      } else if (this.Title == "字典新增") {
        this.form.busTypeCode = this.$route.query.busTypeCode;
        setTimeout(() => {
          // 校验表单
          this.$refs.ruleForm.validate((valid) => {
            if (valid) {
              pagedictAdd({
                busCode: this.form.busCode,
                busName: this.form.busName,
                busTypeCode: this.form.busTypeCode,
                filterValue: this.form.filterValue,
                orderNumber: this.form.orderNumber,
                remark: this.form.remark,
                status: this.form.status,
              }).then(
                (res) => {
                  this.loading = false;
                  this.visible = false;
                  this.searchList();
                  this.$message.success("添加成功");
                  this.form.filterValue = "";
                  this.$refs["ruleForm"].resetFields();
                },
                (err) => {
                  this.loading = false;
                }
              );
            } else {
              this.loading = false;
              return false;
            }
          });
        });
      }
    },
    // 关闭箭头的回调
    handleCancel(e) {
      this.$refs["ruleForm"].resetFields();
      this.form.filterValue = "";
    },
    //删除
    handleDelete(text) {
      this.$confirm({
        title: "确定是否删除?",
        okText: "是",
        cancelText: "否",
        onOk: () => {
          pagedictDel({ id: text.id }).then(
            (res) => {
              this.$message.success("删除成功");
              this.searchList();
            },
            (err) => {}
          );
        },
        onCancel: () => {},
      });
    },
  },
};
</script>

<style lang="less" scoped="scoped">
.bbbbtttt {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  text-shadow: none;
  box-shadow: none;
}
.base-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/.ant-table-body {
  margin-top: -8px !important;
}
.sp_name {
  display: inline-block;
  font-size: 20px;
  margin: 0 0 20px 10px;
}
.fotersa {
  width: 100%;
  height: 100%;
  .title-name {
    width: 100%;
    height: 46px;
    overflow: hidden;
    .sp_name {
      display: inline-block;
      font-size: 20px;
      margin: 0 0 20px 10px;
    }
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .flex label {
    font-size: 16px;
    width: 73px;
  }
  .btone {
    margin-right: 20px;
  }
  .btthree {
    width: 120px;
    margin-left: 10px;
  }
  /deep/.ant-table-thead {
    background-color: #dcf4ff;
  }

  a {
    margin-left: 10px;
    background-color: #E6FEFF;
	  color: #0DB6BA;
	  border-color: #0DB6BA;
  }
  a:hover {
    color: #70b9cf;
  }
}
/deep/.ant-form-item {
  margin-bottom: 0;
}
.title-name::before {
  content: "";
  width: 5px;
  height: 20px;
  display: inline-block;
  overflow: hidden;
  background-color: #0b2464;
}
/deep/ .ant-table-body {
  max-height: 487px;
  overflow: auto;
  margin: 0 !important;
}
/deep/.ant-table-tbody > tr > td {
  padding: 11px 16px;
}
.name {
  font-size: 14px;
  display: inline-block;
  text-align: center;
  width: 26%;
}
.frame {
  width: 74%;
  display: inline-block;
}
.add-mess {
  width: 100%;
  overflow: auto;

  /deep/ .ant-form-item {
    display: flex;
    margin-bottom: 20px !important;
  }
  /deep/ .ant-form-item-label {
    width: 110px;
  }
  /deep/ .ant-form-item-control {
    width: 350px;
  }
}
::v-deep .ant-table-small.ant-table-bordered .ant-table-placeholder {
  display: none;
}

/deep/ .form .ant-input,

.ant-form-item-control,
.ant-form-item-control-wrapper {
  width: 160px;
}
.fw {
  width: 250px;
}
.oper {
  width: 310px;
}
/deep/ .fl .ant-row .ant-col-6:nth-child(1) {
  width: 74px;
}
/deep/ .fl1 .ant-row .ant-col-6:nth-child(1) {
  width: 54px;
}
/deep/ .ant-input-affix-wrapper {
  width: 160px;
}
/deep/ .ant-col-18 {
  width: 50%;
}
</style>